import type { OrganisationDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getOrganisationDetails(organisationId: string): Promise<OrganisationDetailed> {
  return requestApiJsonOrThrow<OrganisationDetailed>(`admin/organisations/${organisationId}`)
}

export const organisationDetailsQuery = (organisationId: string) => ({
  queryKey: ['organisation', organisationId],
  queryFn: () => getOrganisationDetails(organisationId),
})
